var map = {
	"./icon_dashboard.png": 4231,
	"./icon_db.png": 2946,
	"./icon_dedicatedTeam.png": 6220,
	"./icon_message.png": 2888,
	"./icon_smartphone.png": 3752,
	"./lingua.png": 5469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4846;